export default "__VITE_ASSET__CqoyMAIM__"